<!-- Header - Desk -->
<mat-toolbar class="header">
  <!-- App Name -->
  <div class="header_app-name">
    <mat-icon (click)="toggle()" *ngIf="isAdmin">{{ isMenuOpen ? 'menu_open' : 'menu' }}</mat-icon>
    <label (click)="goToHome()">{{'name-app' | translate }} {{envLabel}}</label>
  </div>
  <div class="header_info" [formGroup]="miFormulario">
    <!-- Language -->
    <div class="header_language">
      <mat-button-toggle-group  formControlName="languageControl">
        <mat-button-toggle value="en" >
          <span>EN</span>
        </mat-button-toggle>
        <mat-button-toggle value="es">
          <span>SP</span>
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>
    <!-- User -->
    <div class="header_user">
      <!-- ID -->
      <div class="header_user-name" mat-button [matMenuTriggerFor]="myProfile">
        <mat-icon aria-label="My Profile">person</mat-icon>
        <!--label>{{user.name!=undefined &&user.name!="" ?user.userName:user.clockNumber}}</label-->
        <label>{{user.name}}</label>
        <mat-icon aria-label="Expand" class="header_user_icon-expand">expand_more</mat-icon>
      </div>
      <!-- Data and actions -->
      <mat-menu class="header_user-menu" #myProfile="matMenu">
        <!--label class="header_user-menu-name" mat-menu-item *ngIf="user.firstName!=undefined">{{user.firstName}} {{user.lastName}}</label-->
        <label class="header_user-menu-name" mat-menu-item *ngIf="user.name!=undefined">{{user.name}}</label>
        <button mat-menu-item [routerLink]="['/home/supplier_list']" *ngIf="user.admin">{{ "button-supplier-list" | translate}}</button>
        <!--button mat-menu-item>Auto Registration</button-->
        <button mat-menu-item [routerLink]="['/home/change_password']">{{'label_change_password' | translate }}</button>
        <div class="termsconditions">
          <a (click)="showTermsAndConditions()" >{{ "label-register-terms-link" | translate }}</a>
        </div>
        <button (click)="logout()" mat-menu-item>
          <mat-icon>logout</mat-icon> 
          <span>{{'log-out' | translate }}</span>
        </button>
      </mat-menu>
    </div>
    <!-- Plant-->
    <!-- <div class="header_select-plant">
      <mat-icon aria-label="Plant">business</mat-icon>
      <mat-form-field appearance="fill">
        <div class="header_select-plant-option">
          <mat-select formControlName="selectedPlant">
            <mat-option *ngFor="let plant of plants" [value]="plant.code" [ngClass]="'header_select-plant-text'">
              {{ plant.name }}
            </mat-option>
          </mat-select>
        </div>
      </mat-form-field>
    </div> -->
    <!-- Logo -->
    <div class="header_logo">
      <img src="./assets/images/components/logoSchaeffler.svg">
    </div>
  </div>
</mat-toolbar>
